import { MenuLinks } from '@/constants/menu'

/** Routes that keep the dashboard left sidebar (dark nav) visible. */
export const dashboardShellRoutes: string[] = [
	MenuLinks.Dashboard,
	MenuLinks.ManageUsers,
	MenuLinks.MySubscriptions,
	MenuLinks.MyCustomPlanRequests,
	MenuLinks.BuySubscriptionPlan,
	MenuLinks.ManageEmailLog,
	MenuLinks.ViewAdministratorSubMenu,
	MenuLinks.ManageSubscriptionPlans,
	MenuLinks.ManagePromoCodes,
	MenuLinks.Campaigns,
	MenuLinks.ManageCustomPricing,
	MenuLinks.ManageCustomPlanRequests,
	MenuLinks.SubscriptionSales,
	MenuLinks.Transactions,
	// Settings sub-pages — navigated to from the Settings sub-menu tile
	MenuLinks.ManageRoles,
	MenuLinks.ManageLookUps,
	MenuLinks.ManageLookUpValues,
	MenuLinks.ManagePlatformLookUps,
	MenuLinks.ManagePlatformLookUpValues,
	MenuLinks.ManageSettings,
	MenuLinks.ManageEmailTemplate,
	MenuLinks.ManageLanguage,
	MenuLinks.ManageLanguageLocalizations,
	MenuLinks.ManageTenants,
	MenuLinks.EditTenantDetails,
	MenuLinks.CustomerDetail,
	MenuLinks.Notifications,
	MenuLinks.OfflineGrant,
	MenuLinks.PaymentHistory,
	MenuLinks.PaymentMethods,
	MenuLinks.ManageProfile,
	MenuLinks.HelpSupport,
	MenuLinks.ManageSqlDbdInstaller,
	MenuLinks.ManageOrgPermissions,
]

export const isDashboardShellRoute = (pathname: string) => {
	const normalized = pathname.replace(/\/$/, '') || '/'
	return dashboardShellRoutes.some((route) => {
		const staticPrefix = route.split('/:')[0]
		return normalized === route || normalized.startsWith(`${staticPrefix}/`) || normalized === staticPrefix
	})
}
